































import { Component, Vue, Prop } from 'vue-property-decorator'
import { UnitProtectPlanData, getList, removeData } from '@/api/heritageUnit/unitProtectPlan'
import UnitProtectPlanForm from './form.vue'

@Component({
  components: {
    UnitProtectPlanForm
  }
})
export default class UnitProtectPlanList extends Vue {
  public name = 'UnitProtectPlanList'
  @Prop({ default: 0 })
  public unitId: number = 0

  public loading = false
  public list: UnitProtectPlanData[] = []
  // dynamic component
  public $refs!: {
    planCtrl: UnitProtectPlanForm
  }
  public loadData() {
    if (this.unitId == 0) {
      this.$message({
        message: '文保单位未匹配，请检查',
        type: 'warning'
      })
      console.log('UnitId为0，请赋值')
    }
    else {
      this.fetchData()
    }
  }
  public fetchData() {
    this.loading = true
    getList(this.unitId).then((response: { data: any }) => {
      this.list = response.data
      this.loading = false
    }).catch((error: any) => {
      console.log(error)
    })
  }
  public addData() {
    this.showDataForm(0)
  }
  public editData(index: number) {
    const item = this.list[index]
    this.showDataForm(item.Id)
  }
  public removData(index: number) {
    this.$confirm(`确定要删除吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        var item = this.list[index]
        removeData(item.Id).then(() => {
          this.$message({ type: 'success', message: '删除成功' })
          this.list.splice(index, 1)
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '操作已取消'
        })
      })
  }
  //修改后，直接保存到数据库里
  public showDataForm(id: number) {
    window.eventBus.$emit('openUnitProtectPlanForm', {
      unitId: this.unitId,
      dataId: id
    })
  }
  public closeDataForm() {
    console.log('closeUnitProtectPlanForm')
  }
  public mounted() {
    //按需加载
    window.eventBus.$on('loadUnitProtectPlanList', (unitId: number) => {
      this.unitId = unitId
      this.fetchData()
    })
    window.eventBus.$on('submitUnitProtectPlanForm', (info: any) => {
      this.fetchData()
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('loadUnitProtectPlanList')
    window.eventBus.$off('submitUnitProtectPlanForm')
  }
}
